import type { UseSuspenseQueryOptions } from '@tanstack/react-query';

import { SDKError } from '@crossnokaye/typescript-sdk/models/errors';

import { trendsListDeviceTrendPoints } from '@repo/sdk/funcs/trendsListDeviceTrendPoints';
import { DeviceTrendPoints, ListDeviceTrendPointsResponse } from '@repo/sdk/models/components';
import { ListDeviceTrendPointsRequest } from '@repo/sdk/models/operations';

import { GaiaClientFunction } from '@/client/types';

import { GaiaQueryWithAgentId } from '../types';

const transformListDeviceTrendPointsResponse = (
  data: ListDeviceTrendPointsResponse
): DeviceTrendPoints[] => {
  return data.values ?? [];
};

export interface ListDeviceTrendPointsQueryProps extends GaiaQueryWithAgentId {
  client: GaiaClientFunction;
  transform?: (data: ListDeviceTrendPointsResponse) => DeviceTrendPoints[] | undefined | any;
}

export const listDeviceTrendPointsQuery = ({
  agentId,
  client,
  transform = transformListDeviceTrendPointsResponse,
}: ListDeviceTrendPointsQueryProps): UseSuspenseQueryOptions<
  ListDeviceTrendPointsResponse,
  SDKError,
  DeviceTrendPoints[] | undefined | any
> => {
  return {
    queryKey: [agentId, 'deviceTrendPoints'],
    queryFn: () =>
      client<ListDeviceTrendPointsRequest, ListDeviceTrendPointsResponse>({
        gaiaFunc: trendsListDeviceTrendPoints,
        request: {
          agentId: agentId!,
        },
      }),
    staleTime: 5 * 60 * 1000, // 5 minutes
    select: transform,
  };
};
